enum MessageType {
    Sms = 1,
    Email = 2
}

export default MessageType;
